import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function CookiePolicy() {
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16 md:pb-20">
        <div className="px-4 md:px-6 max-w-[800px] mx-auto">
          <nav className="text-xs text-foreground-500 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-foreground-900 cursor-pointer transition-colors">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-foreground-700 font-medium">Cookie Policy</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-8">Cookie Policy</h1>

          <div className="space-y-6 text-foreground-700 leading-relaxed text-sm">
            <p><strong>Ultimo aggiornamento:</strong> Luglio 2026</p>

            <p>
              Questa Cookie Policy spiega come itaobuyspread.pics utilizza i cookie e tecnologie simili.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Cosa Sono i Cookie</h2>
            <p>
              I cookie sono piccoli file di testo che i siti web salvano sul tuo dispositivo durante la 
              navigazione. Servono a ricordare le tue preferenze e a migliorare l&apos;esperienza di navigazione.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Cookie Utilizzati</h2>
            <p>
              itaobuyspread.pics utilizza esclusivamente cookie tecnici di sessione, necessari per il 
              corretto funzionamento del sito. Questi cookie non raccolgono informazioni personali e 
              vengono eliminati automaticamente alla chiusura del browser.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Cookie di Terze Parti</h2>
            <p>
              Non utilizziamo cookie di terze parti per finalità di marketing, analisi o profilazione.
            </p>

            <div className="mt-8">
              <Link to="/" className="text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors">
                &larr; Torna alla Home
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Cookie Policy - Itaobuy Spreadsheet',
            url: 'https://itaobuyspread.pics/cookie-policy',
            description: 'Cookie Policy di itaobuyspread.pics. Informazioni sull\'utilizzo dei cookie e tecnologie simili.',
            inLanguage: 'it',
            dateModified: '2026-07-14',
          }),
        }}
      />
    </>
  );
}